import { questTotemStorageKey } from '../constants/totem'

const hasSessionStorage = () => typeof window !== 'undefined' && !!window.sessionStorage

export const readTotemToken = (eventSlug: string, questUid: string): string | null => {
  if (!hasSessionStorage()) return null
  return window.sessionStorage.getItem(questTotemStorageKey(eventSlug, questUid))
}

export const writeTotemToken = (eventSlug: string, questUid: string, token: string): void => {
  if (!hasSessionStorage()) return
  window.sessionStorage.setItem(questTotemStorageKey(eventSlug, questUid), token)
}

export const clearTotemToken = (eventSlug: string, questUid: string): void => {
  if (!hasSessionStorage()) return
  window.sessionStorage.removeItem(questTotemStorageKey(eventSlug, questUid))
}
